(function() {
  let btnsloadmore = document.querySelectorAll(".loadmore_btn-wrapper");
  if(Boolean(btnsloadmore)){
    btnsloadmore.forEach(btn=>{
      btn.addEventListener("click",e=>{
        e.preventDefault();

        Array.from(btn.previousSibling.children).forEach(item=>{
          item.classList.remove("hidden");
        });
        btn.classList.add("hidden");

      });
    })
  }
})();
